/* eslint-disable react/no-array-index-key,react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import classNames from 'classnames';
import styles from './index.styl';

const renderErrors = errors => {
  if (Array.isArray(errors)) {
    return errors.map((error, i, arr) => {
      const isLastItem = i < arr.length - 1;
      return (
        <div key={i} className={classNames({ mb1: isLastItem })}>
          {error}
        </div>
      );
    });
  }

  return errors;
};

const PlainTextErrorBlock = ({ errors, style, className }) => (
  <div styleName="errorMsg" {...{ className, style }}>
    {renderErrors(errors)}
  </div>
);

PlainTextErrorBlock.propTypes = {
  errors: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
  style: PropTypes.object,
  className: PropTypes.string,
};

export default CSSModules(PlainTextErrorBlock, styles, { allowMultiple: true });



// WEBPACK FOOTER //
// ./src/components/common/ErrorBlock/PlainTextErrorBlock.jsx